import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=72b839ad&"
import script from "@/scripts/adminManager/systemManager/roleManagement.js?vue&type=script&lang=js&"
export * from "@/scripts/adminManager/systemManager/roleManagement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports